import Sites from '@toasttab/shared/src/data/Sites.json'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'

const getAppStoreBadgeLocaleDirectory = (language: string): string => {
  // Similar logic to formatLang in linkUtils.ts but for icon directories
  if (!language) {
    return 'en'
  }

  switch (language.toLowerCase()) {
    case 'es-us':
    case 'es':
      return 'es'
    case 'zh-us':
      return 'zh'
    case 'fr-ca':
      return 'fr-ca'
    default:
      return 'en'
  }
}

const getAvailableIconLocales = (): string[] => {
  // Get unique locale directories from Sites.json
  const localeDirectories = Sites.sites
    .map((site) => getAppStoreBadgeLocaleDirectory(site.regionCode))
    .filter((value, index, self) => self.indexOf(value) === index) // Remove duplicates

  return localeDirectories
}

const getAppStoreBadge = (
  locale: string = 'en',
  localizedText?: {
    appStoreAlt?: string
    googlePlayAlt?: string
  }
): {
  [key: string]: { src: string; alt: string }
} => {
  const localeDir = getAppStoreBadgeLocaleDirectory(locale)

  // Dynamically determine available locale directories from Sites.json
  const availableLocales = getAvailableIconLocales()
  const useLocaleDir = availableLocales.includes(localeDir)

  return {
    appstore: {
      src: useLocaleDir
        ? resolvePrefix(`/svg/footer/${localeDir}/apple_btn.svg`)
        : resolvePrefix('/svg/footer/apple_btn.svg'),
      alt: localizedText?.appStoreAlt || 'Download on the App Store'
    },
    googleplay: {
      src: useLocaleDir
        ? resolvePrefix(`/svg/footer/${localeDir}/googleplay_btn-color.svg`)
        : resolvePrefix('/svg/footer/googleplay_btn-color.svg'),
      alt: localizedText?.googlePlayAlt || 'Get it on Google Play'
    }
  }
}

export { getAppStoreBadge }
